import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import DomainImage from '../../../../../components/DomainImage';

export const COLUMNS = (t) => [
    {
        label: t('ai_tracking.google_search_top_urls.title'),
        key: 'title',
        data: 'title',
        Component: Cell,
        cellSize: 'minmax(180px, 1.5fr)',
        sortType: 'string',
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return item.domain;
            return (
                <strong className="wrap-text">
                    {item.title === 'None' ? getName(data) : item.title}{' '}
                    <a
                        target="_blank"
                        className="link-website d-inline-flex align-items-center justify-content-center"
                        href={item.url}
                        rel="noreferrer"
                    >
                        <i className="icon-external-link"></i>
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('ai_tracking.google_search_top_urls.domain'),
        key: 'domain',
        data: 'domain',
        sortType: 'string',
        cellSize: 'minmax(180px, 1.5fr)',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.domain;
            return (
                <div>
                    <strong className="wrap-text d-flex align-items-center">
                        <DomainImage domain_name={item.domain} className="domain_img" />
                        <span>{item.domain}</span>
                    </strong>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.google_search_top_urls.ranking_visibility'),
        key: 'rankingVisibility',
        data: 'rankingVisibility',
        Component: Cell,
        info: t('ai_tracking.google_search_top_urls.ranking_visibility_info'),
        renderCell: ({ item, csvDownload }) => {
            const data = (item.urlScore / item.totalScore) * 100;
            if (csvDownload) return numeral(data).format('0.00');
            return <div className="wrap-text">{numeral(data).format('0,0.00')}%</div>;
        },
    },
    {
        label: t('ai_tracking.google_search_top_urls.unique_titles'),
        key: 'uniqueTitles',
        data: 'uniqueTitles',
        Component: Cell,
    },
    {
        label: t('ai_tracking.google_search_top_urls.avg_position'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <div className="wrap-text">{numeral(data).format('0,0.00')}</div>;
        },
    },
    {
        label: t('ai_tracking.google_search_top_urls.rankings'),
        key: 'rankings',
        data: 'rankings',
        Component: Cell,
    },
    {
        label: t('ai_tracking.google_search_top_urls.total_runs'),
        key: 'totalRuns',
        data: 'totalRuns',
        Component: Cell,
    },
];

function getName(url) {
    try {
        const parsedUrl = new URL(url);
        const parts = parsedUrl.pathname.split('/').filter(Boolean); // remove empty parts like ""
        return parts.length ? parts[parts.length - 1] : '';
    } catch (error) {
        return url;
    }
}
